// @flow

import { connect } from "react-redux";
import Photo from "./view";
import { showPhoto } from "../../../state/blogs/actions";

export default connect(
    () => ({}),
    dispatch => ({
        onShowPhoto: payload => dispatch(showPhoto(payload))
    })
)(Photo);



// WEBPACK FOOTER //
// ./src/blog-card/photos/photo/index.js